import { KeyRound } from "lucide-react";

export const AreaStatusBadge = ({ status, testId }) => {
  if (!status) return null;
  return (
    <span className="ml-2 inline-flex items-center gap-1 align-middle normal-case" data-testid={testId}>
      <span title="Area Riservata attiva" data-testid={`${testId}-key`} className="inline-flex items-center justify-center h-5 w-5 rounded-md bg-sky-500/15 text-sky-400">
        <KeyRound className="h-3 w-3" />
      </span>
      {status.online && (
        <span title="Connesso all'Area Riservata" data-testid={`${testId}-online`} className="inline-flex items-center gap-1 text-[10px] font-semibold text-emerald-400">
          <span className="h-2 w-2 rounded-full bg-emerald-500 shadow-[0_0_6px_rgba(16,185,129,0.8)] animate-pulse" />
          Online
        </span>
      )}
    </span>
  );
};
